import { render, staticRenderFns } from "./CadastroCriancaPublico.vue?vue&type=template&id=68a68b76&scoped=true"
import script from "./CadastroCriancaPublico.vue?vue&type=script&lang=js"
export * from "./CadastroCriancaPublico.vue?vue&type=script&lang=js"
import style0 from "./CadastroCriancaPublico.vue?vue&type=style&index=0&id=68a68b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a68b76",
  null
  
)

export default component.exports